<template>
  <div class="auth-wrapper auth-v2">
    <b-overlay :show="show" no-wrap />

    <b-row class="auth-inner m-0">
      <!-- Brand logo-->

      <div class="brand-logo">
        <img src="@/assets/images/logo/logoNew.svg" />

        <div class="brand-logo-text">Human Resource System</div>
      </div>

      <!-- /Brand logo-->

      <!-- Left Text-->

      <b-col lg="8" class="d-none d-lg-flex align-items-center ">
        <div class="w-100 d-lg-flex align-items-center justify-content-center ">
          <b-img
            style="width: 100%;height: auto;"
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>

      <!-- /Left Text-->

      <!-- Login-->

      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col class=" mx-auto">
          <b-card-title class="font-weight-bold mb-1 fw-7 black-text ">
            Welcome to HR System!
          </b-card-title>

          <b-card-text class="mb-1 secondary-text ">
            Select your device’s operating system.
          </b-card-text>

          <!-- form -->

          <!-- tab -->

          <div class="flex tab cursor-pointer">
            <div
              class="tab-item  "
              :class="{ 'tab-active': mobileType == 2 }"
              @click="changeTab(2)"
            >
              Android
            </div>

            <div
              class="tab-item"
              :class="{ 'tab-active': mobileType == 1 }"
              @click="changeTab(1)"
            >
              IOS
            </div>
          </div>

          <div
            id="qrcode"
            ref="qrcode"
            style="width: 210px; height: 210px;margin:46px auto 16px auto"
          ></div>

          <p class="qr-text">Scan QR code to download app</p>

          <div class="fw-7 primary-text cursor-pointer" @click="back">
            Sign in with MCC Portal app
          </div>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BFormSelect,
  BImg,
  BForm,
  BButton,
  BOverlay,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import { resetRouter } from '@/router/index'
import Password from '@/views/common/Password.vue'
import ResetPassword from '@/views/common/resetPassword.vue'
import { loginByAiisToken } from '@/api/user'
import { getToken } from '@/util/auth'
import QRCode from 'qrcodejs2'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormSelect,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    BOverlay,
    Password,
    ResetPassword,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      sideImg: require('@/assets/images/logo/vector-sign-in.png'),
      mobileType: '2',
    }
  },
  mounted() {
    this.generateQRCode()
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/logo/vector-sign-in.png')
        return this.sideImg
      }
      return this.sideImg
    },
    appUrl() {
      const iosUrl = 'https://apps.apple.com/us/app/mcc-portal/id6445848183'
      const androidUrl =
        'https://play.google.com/store/apps/details?id=uni.UNIA992726&hl=en_SG'
      return this.mobileType == 1 ? iosUrl : androidUrl
    },
  },

  methods: {
    back() {
      this.$router.back()
    },
    handleToAppPage() {},

    i18n(param) {
      return this.$t(`_default.${param}`)
    },
    changeTab(tab) {
      this.mobileType = tab
      this.generateQRCode()
    },
    generateQRCode() {
      document.getElementById('qrcode').innerHTML = ''
      new QRCode(this.$refs.qrcode, {
        text: this.appUrl,
        width: 210,
        height: 210,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-auth.scss';
.custom-select {
  padding: 10px;
}
.col {
  padding: 0 !important;
}

// @media (min-width: 992px) {
//   .col-lg-8 {
//     max-width: 1400px;
//     width: calc(100% - 500px) !important;
//   }
//   .col-lg-4 {
//     max-width: 500px;
//   }
// }
.qr-text {
  color: var(--Color-Text-text-color-secondary, #909399);
  text-align: center;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
  margin-bottom: 46px;
}
.tab {
  width: 100%;
  .tab-item {
    padding: 9px 0px;
    width: 50%;
    text-align: center;
    color: #303133;
    text-align: center;
    border-bottom: 2px solid var(--Color-Border-border-color-light, #e4e7ed);

    /* bold/base */
    font-family: 'PingFang SC';
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 157.143% */
  }
  .tab-active {
    color: #7367f0;
    border-bottom: 2px solid #7367f0;
  }
}
</style>
